var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import Success from "@irati/ui/src/Success";
import { injectIntl } from "@irati/utils/lang";
import Div from "./styled/Div";
var SuccessStep = /** @class */ (function (_super) {
    __extends(SuccessStep, _super);
    function SuccessStep(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            saved: false
        };
        return _this;
    }
    SuccessStep.prototype.UNSAFE_componentWillReceiveProps = function (newProps) {
        var onHide = this.props.onHide;
        if (newProps.show) {
            setTimeout(function () {
                onHide();
            }, 2000);
        }
    };
    SuccessStep.prototype.render = function () {
        var _a = this.props, show = _a.show, formatMessage = _a.formatMessage;
        if (!show) {
            return null;
        }
        return (React.createElement(Div, null,
            React.createElement(Success, { message: formatMessage({ id: "admin.components.successStep.success.message" }) })));
    };
    SuccessStep.defaultProps = {};
    return SuccessStep;
}(Component));
export default injectIntl(SuccessStep);
